import { Injectable, ErrorHandler } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  handleError(error: Error) {
    const errorMessage = this._buildErrorMessage(error)
    console.log(`%c${errorMessage}`, 'background: #FFF; color: #FF0000;');
  }

  private _buildErrorMessage(error: Error) {
    return `Description Error: ${error.message}\n\nStackTrace: ${error.stack}`;
  }
}